// packages/api-client/queries/paymentProviders/index.ts
import { useQuery } from "@tanstack/react-query";
export const createPaymentProvidersQueries = (requests, queryClient) => ({
    useListPaymentProviders: (params, options = {}) => useQuery({
        queryKey: ["payment-providers", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listPaymentProviders(params);
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map